<template>
  <div class="flex flex-col w-full">
    <slot />
  </div>
</template>

<script setup>
  import { ref, provide, computed } from 'vue';

  const props = defineProps({
    currentStep: {
      type: Number,
      required: true,
    },
  });

  const items = ref([]);

  provide('stepperRegister', item => {
    items.value.push(item);
    return items.value.length - 1;
  });
  provide(
    'stepCount',
    computed(() => {
      return items.value.length;
    })
  );
  provide(
    'currentStep',
    computed(() => {
      return props.currentStep;
    })
  );
</script>
